module.exports = __webpack_public_path__ + "img/ZJ5347.140b3769.png";